import DialogReturnCustomer from "./DialogReturnCustomer";

export default {
    name     : 'dialog_return_customer',
    component: DialogReturnCustomer,
    dialog   : {
        'max-width': "500px",
        'persistent': true
    }
}
